import { render, staticRenderFns } from "./asdwccp.vue?vue&type=template&id=72723330&"
import script from "./asdwccp.vue?vue&type=script&lang=js&"
export * from "./asdwccp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports